export const getFromBrowserStorage = (key) => {
  return localStorage.getItem(key) || sessionStorage.getItem(key);
};

export const setInBrowserStorage = (key, value, useSessionStorage = false) => {
  const storage = useSessionStorage ? sessionStorage : localStorage;
  storage.setItem(key, String(value));
};

export const getJsonFromBrowserStorage = (key) => {
  const rawValue = getFromBrowserStorage(key);
  if (!rawValue) return null;

  try {
    return JSON.parse(rawValue);
  } catch {
    return null;
  }
};

export const removeFromBothStorages = (key) => {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export const clearAuthStorage = () => {
  const authKeys = [
    "accessToken",
    "tokenType",
    "tokenExpiresIn",
    "tokenExpiration",
    "tokenExpiry",
    "userData",
    "currentRole",
    "loginType",
  ];

  authKeys.forEach((key) => removeFromBothStorages(key));
};
